import { render, staticRenderFns } from "./InventoryBalanceByProduct.vue?vue&type=template&id=4376e9b6"
import script from "./InventoryBalanceByProduct.vue?vue&type=script&lang=js"
export * from "./InventoryBalanceByProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4376e9b6')) {
      api.createRecord('4376e9b6', component.options)
    } else {
      api.reload('4376e9b6', component.options)
    }
    module.hot.accept("./InventoryBalanceByProduct.vue?vue&type=template&id=4376e9b6", function () {
      api.rerender('4376e9b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventory/InventoryBalanceByProduct.vue"
export default component.exports